module.exports = __webpack_public_path__ + "img/cszq_banner_2.75bef3af.png";